
import type { ReactNode } from 'react';

import ActivityLogReportPage from '../../features/AdminDashboard/Pages/ActivityLogReportPage';
import SummaryReportPage from '../../features/AdminDashboard/Pages/SummaryReportPage';
import AccessCreationReportPage from '../../features/AdminDashboard/Pages/AccessCreationReportPage';
import AccessRevocationReportPage from '../../features/AdminDashboard/Pages/AccessRevocationReportPage';
import AccessModificationReportPage from '../../features/AdminDashboard/Pages/AccessModificationReportPage';
import TrackingReportPage from '../../features/AdminDashboard/reports/components/TrackingReportPage';

export interface ReportRouteConfig {
  path: string;
  permission: string;
  element: ReactNode;
}

export const reportRoutes: ReportRouteConfig[] = [
  {
    path: '/public-report/activity-log',
    permission: 'ActivityLogReport',
    element: <ActivityLogReportPage />,
  },
  {
    path: '/public-report/summary-report',
    permission: 'SummaryReport',
    element: <SummaryReportPage />,
  },
  {
    path: '/public-report/access-creation',
    permission: 'AccessCreationReport',
    element: <AccessCreationReportPage />,
  },
  {
    path: '/public-report/access-revocation',
    permission: 'AccessRevocationReport',
    element: <AccessRevocationReportPage />,
  },
  {
    path: '/public-report/access-modification',
    permission: 'AccessModificationReport',
    element: <AccessModificationReportPage />,
  },
  {
    path: '/public-report/tracking-report',
    permission: 'TrackingReport',
    element: <TrackingReportPage />,
  },
];
